'use client';

import { formatCurrency } from '@ahm/common-helpers';
import { Button, Group, Text, rem } from '@mantine/core';
import { useParams, useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useTransition } from 'react';
import type { SubscriptionPlan } from '../api';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type SubscriptionFooterProps = {
  plan: SubscriptionPlan;
};

export default function SubscriptionFooter({ plan }: SubscriptionFooterProps) {
  const tSubscription = useTranslations('subscription');
  const isMobile = useIsMobile();
  const router = useRouter();
  const { id } = useParams();
  const [isPending, startTransition] = useTransition();

  function handleSelectPlan() {
    startTransition(() => {
      router.push(`/checkout/subscription/${id as string}/${plan.id}`);
    });
  }

  return (
    <>
      {plan && (
        <Group
          gap={0}
          bg="white"
          justify={isMobile ? 'center' : 'space-between'}
          w="100%"
          pos={isMobile ? 'fixed' : 'relative'}
          left={0}
          right={0}
          bottom={0}
          p={isMobile ? rem(16) : rem(24)}
          pt={isMobile ? rem(16) : rem(12)}
          style={{
            zIndex: 100,
            boxShadow: isMobile
              ? '0px 2px 4px 0px rgba(0, 0, 0, 0.10)'
              : '0px -2px 4px 0px rgba(0, 0, 0, 0.10)',
          }}
        >
          <Group
            mb={isMobile ? rem(16) : 0}
            align="center"
            justify="center"
            gap={rem(4)}
          >
            {/* {plan.original_price && (
              <>
                <Text
                  td="line-through"
                  c="neutral.3"
                  size="md"
                  lh={rem(20)}
                  fw={600}
                >
                  {formatCurrency(plan.original_price)}
                </Text>
              </>
            )} */}
            <Text c="primary.6" size={rem(24)} fw={700}>
              {formatCurrency(plan.price)}
            </Text>
          </Group>

          <Button
            loading={isPending}
            onClick={handleSelectPlan}
            w={isMobile ? '100%' : '320px'}
            size="lg"
          >
            <Text fw={700} size="md">
              {tSubscription('select_this_package')}
            </Text>
          </Button>
        </Group>
      )}
    </>
  );
}
